/* eslint-disable no-unused-vars */
import axios from 'axios'

import {
    GET_JOB,
    GET_JOB_CANDIDATES,
    SET_JOB_VIEW_LOADER,
    CLEAR_JOB_CANDIDATES,
} from 'store/actions/actionTypes'
import { ITEMS_PER_PAGE } from 'Data/constants'
import { getAuthToken } from 'store/authConfig'
import { addToast } from 'components/Toast/actions'

const setLoader = loader => ({
    type: SET_JOB_VIEW_LOADER,
    loader,
})

const getJobDetail = job => ({
    type: GET_JOB,
    job,
})

const getCandidateList = (data, size, filters, sorter, activeFilters, activeSorter) => ({
    type: GET_JOB_CANDIDATES,
    loader: false,
    candidates: data.data,
    total: data.pagination_data.total_count,
    size,
    filters,
    sorter,
    activeFilters,
    activeSorter,
})

export const clearCandidates = () => ({
    type: CLEAR_JOB_CANDIDATES,
    total: 0,
    job: {},
    candidates: [],
    size: ITEMS_PER_PAGE,
    filters: {},
    sorter: 'candidateId',
    activeSorter: {},
    activeFilters: [],
})

const errorHandler = (errorMessage, dispatch) => {
    if (errorMessage.response?.data.message) {
        dispatch(addToast('error', 'Error', errorMessage.response.data.message))
        dispatch(setLoader(false))
    }
    const message = errorMessage.message || 'Something went wrong, please try after sometime.'
    dispatch(addToast('error', 'Error', message))
    dispatch(setLoader(false))
}

export const getJob = id => {
    const url = `/api/jobs/${id}`

    getAuthToken()
    return dispatch => {
        dispatch(setLoader(true))
        axios.get(url)
            .then(response => {
                if (response.data.data) dispatch(getJobDetail(response.data.data))
            })
            .catch(err => dispatch(errorHandler(err, dispatch)))
    }
}

export const getCandidates = (page = 1, size = 10, jobId, filters, sorter, activeFilters, activeSorter, history, eventId) => {
    let url = `/api/jobs/candidate?job__job_id=${jobId}&page=${page}&page_count=${size}`

    if (eventId) url += `&hiring_event__event_id=${eventId}`

    Object.keys(filters).map(item => {
        if (item === 'hiring_status') url += `&${item}=${filters[item]}`
        else url += `&${item}__icontains=${filters[item]}`
        return null
    })

    if (sorter) url += `&ordering=${sorter}`

    getAuthToken()
    return dispatch => {
        dispatch(setLoader(true))
        axios.get(url)
            .then(response => {
                if (response.data.data && response.data.pagination_data) dispatch(getCandidateList(response.data, size, filters, sorter, activeFilters, activeSorter))
                if (response && response.data.data.length === 0 && response.data.error === 'Invalid page.' && history) {
                    const total = response.data.total
                    let nextPage
                    if (total % 10 > 0) nextPage = total > 10 ? Math.ceil(total / 10) : 1
                    else nextPage = Math.floor(total / 10)
                    history.push({ pathname: '', search: `?page=${nextPage}` })
                }
            })
            .catch(err => dispatch(errorHandler(err, dispatch)))
    }
}
